const Config = {
  apiUrl: process.env.VUE_APP_API_URL ?? 'https://back.angelleague.io',
  authApiUrl: process.env.VUE_APP_SOCKET_URL ?? 'https://auth.angelleague.io',
}

export const API_URL = Config.apiUrl
export const AUTH_API_URL = Config.authApiUrl
export default Config
